<button #floatingRef qai-button [kind]="buttonKind" [size]="buttonSize">
  <qai-icon *ngIf="buttonIcon" [kind]="buttonIcon" positionStart />
  {{ buttonLabel }}
</button>
<qai-menu
  [qaiFloating]="floatingRef.elementRef.nativeElement"
  [placement]="'below-start'"
  [events]="['click']"
  [offset]="4"
>
  <qai-menusection>
    <button
      *ngFor="let option of options"
      qai-menuitem
      [label]="option.label"
      (click)="onMenuItemClick(option.value)"
    ></button>
  </qai-menusection>
</qai-menu>
